import React from "react";

const CasePerformance = ({ casePerformance = [] }) => {
  const siteData = Array.isArray(casePerformance) ? casePerformance : [];

  const totalEntryToSign = siteData.reduce(
    (sum, s) => sum + s.avgEntryToSign,
    0
  );
  const totalOpenToSign = siteData.reduce((sum, s) => sum + s.avgOpenToSign, 0);

  // Format time from days to a readable format (consistent with PDF export)
  const formatTimeFromDays = (days) => {
    if (!days || days === 0) {
      return '0 Days';
    }

    const totalMinutes = Math.round(days * 24 * 60);
    
    if (totalMinutes < 60) {
      return `${totalMinutes} min`;
    } else if (totalMinutes < 1440) { // Less than 24 hours
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      if (minutes === 0) {
        return `${hours} hr`;
      }
      return `${hours} hr ${minutes} min`;
    } else { // 24 hours or more
      const totalDays = Math.floor(totalMinutes / 1440);
      const remainingHours = Math.floor((totalMinutes % 1440) / 60);
      
      if (remainingHours === 0) {
        return `${totalDays} Days`;
      }
      return `${totalDays} Days ${remainingHours} hr`;
    }
  };

  if (!siteData.length) {
    return (
      <div className="text-white">
        <span className="text-xl font-bold">Case Performance</span>
        <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />
        <div className="text-gray-400">No data available</div>
      </div>
    );
  }

  return (
    <div className="text-white">
      <span className="text-xl font-bold">Case Performance</span>
      <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />
      <div className="grid md:grid-cols-2 gap-10">
        {/* Entry to Signing */}
        <div>
          <div className="flex justify-between text-sm font-semibold h-[30px] mb-3">
            <p>Average Time from Case Entry to Signing</p>
          </div>
          {siteData.map((site) => (
            <div key={`entry-${site.siteName}`} className="mb-12">
              <div className="flex justify-between text-sm h-[30px]">
                <span>{site.siteName}</span>
                <span>{formatTimeFromDays(site.avgEntryToSign)}</span>
              </div>
              <div className="h-1.5 bg-gray-700 rounded">
                <div
                  className="h-full bg-[#5A3EFF] rounded"
                  style={{
                    width: `${
                      totalEntryToSign > 0
                        ? (site.avgEntryToSign / totalEntryToSign) * 100
                        : 0
                    }%`,
                  }}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Open to Signing */}
        <div>
          <div className="flex justify-between text-sm font-semibold h-[30px] mb-3">
            <p>Average Time from Case Opening to Signing</p>
          </div>
          {siteData.map((site) => (
            <div key={`open-${site.siteName}`} className="mb-12">
              <div className="flex justify-between text-sm h-[30px]">
                <span>{site.siteName}</span>
                <span>{formatTimeFromDays(site.avgOpenToSign)}</span>
              </div>
              <div className="h-1.5 bg-gray-700 rounded">
                <div
                  className="h-full bg-[#5A3EFF] rounded"
                  style={{
                    width: `${
                      totalOpenToSign > 0
                        ? (site.avgOpenToSign / totalOpenToSign) * 100
                        : 0
                    }%`,
                  }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CasePerformance;
